/* eslint-disable max-len */
import aurora from "../assets/sounds/notification_sound(3).mp3";
import chord from "../assets/sounds/notification_sound(2).mp3";
import bell from "../assets/sounds/notification_sound(1).mp3";
import hello from "../assets/sounds/notification_sound.mp3";
import input from "../assets/sounds/notification-sound-7062.mp3";

export const TUNES = [
  {
    audio: null,
    name: "None",
    id: 0,
  },
  {
    audio: aurora,
    name: "Aurora",
    id: 1,
  },
  {
    audio: chord,
    name: "Chord",
    id: 2,
  },
  {
    audio: bell,
    name: "Bell",
    id: 3,
  },
  {
    audio: input,
    name: "Input",
    id: 4,
  },
  {
    audio: hello,
    name: "Hello",
    id: 5,
  },
];

export const STATUS_COLOR = {
  pending: "tw-bg-[#EBFAFF] tw-text-[#2498CE]",
  success: "tw-bg-[#EBFAFF] tw-text-[#2498CE]",
  owing: "tw-bg-[#FFF0F2] tw-text-[#842432]",
  paid: "tw-bg-[#EBFAFF] tw-text-[#2498CE]",
};
/** @type Record<string, string> */
export const SPECIALTIES_MAP = {
  ophthalmology: "Ophthalmology",
  generalPractice: "General Practice",
  obgyn: "Obstetrics and Gynaecology",
  endocrinology: "Endocrinology",
  cardiology: "Cardiology",
  paediatrician: "Paediatrician",
  physiotherapy: "Physiotherapy",
  orthopaedic: "Orthopaedic",
  dentist: "Dentist",
  urology: "Urology",
  neurology: "Neurology",
  oncology: "Oncology",
  nephrology: "Nephrology",
  cardiothoracic: "Cardio Thoracic",
  generalSurgeries: "General Surgeries",
  rheumatology: "Rheumatology",
  generalFamilyPhysician: "General Family Physician",
};

export const SPECIALTY_KEYS = {
  ophthalmology: "ophthalmology",
  generalPractice: "generalPractice",
  obgyn: "obgyn",
  endocrinology: "endocrinology",
  cardiology: "cardiology",
  paediatrician: "paediatrician",
  physiotherapy: "physiotherapy",
  orthopaedic: "orthopaedic",
  dentist: "dentist",
  urology: "urology",
  neurology: "neurology",
  oncology: "oncology",
  nephrology: "nephrology",
  cardiothoracic: "cardiothoracic",
  generalSurgeries: "generalSurgeries",
  rheumatology: "rheumatology",
  generalFamilyPhysician: "generalFamilyPhysician",
};

export const NEW_SPECIALTIES = [
  { label: "Ophthalmology", value: "ophthalmology" },
  { label: "General Practice", value: "generalPractice" },
  { label: "Obstetrics and Gynaecology", value: "obgyn" },
  { label: "Endocrinology", value: "endocrinology" },
  { label: "Cardiology", value: "cardiology" },
  { label: "Paediatrician", value: "paediatrician" },
  { label: "Physiotherapy", value: "physiotherapy" },
  { label: "Orthopaedic", value: "orthopaedic" },
  { label: "Dentist", value: "dentist" },
  { label: "Urology", value: "urology" },
  { label: "Neurology", value: "neurology" },
  { label: "Oncology", value: "oncology" },
  { label: "Nephrology", value: "nephrology" },
  { label: "Cardio Thoracic", value: "cardiothoracic" },
  { label: "General Surgeries", value: "generalSurgeries" },
  { label: "Rheumatology", value: "rheumatology" },
  { label: "General Family Physician", value: "generalFamilyPhysician" },
];

export const SECTIONS = ["Vitals", "Consultant", "Outpatient Procedure"];

export const GUEST_PATIENT_CONVERSION_MESSAGE =
  "THIS SELECTED NAME BELONGS TO A GUEST PATIENT, CONVERT GUEST TO PATIENT TO PROCEED";

/** Dims a non-button trigger (icon, div, li) that can't be clicked. */
export const DISABLED_TRIGGER_CLASS = "tw-opacity-50 tw-cursor-not-allowed";

export const POINT_OF_SALE = [
  { label: "Retail Item", value: "retail" },
  { label: "Prescription Item", value: "prescription" },
  { label: "Non Medical Item", value: "service" },
];
export const PERSONAL_DETAILS = [
  {
    _id: 1,
    checked: false,
    text: "Location",
    value: "address",
  },
  { _id: 2, checked: false, text: "Email Address", value: "email" },
  { _id: 16, checked: false, text: "Religion", value: "religion" },
];
export const NEXT_OF_KIN = [
  { _id: 7, checked: false, text: "Full Name", value: "nokFullName" },
  { _id: 8, checked: false, text: "Relationship", value: "nokRelationship" },
  { _id: 9, checked: false, text: "Phone Number", value: "nokPhoneNumber" },
  { _id: 10, checked: false, text: "Email Address", value: "nokEmail" },
  {
    _id: 11,
    checked: false,
    text: "Location",
    value: "nokAddress",
  },
];
export const HMO_DETAILS = [{ _id: 12, checked: false, text: "HMO/Provider", value: "sponsors" }];
export const EXTRA_DETAILS = [
  { _id: 13, checked: false, text: "Referral", value: "referral" },
  { _id: 14, checked: false, text: "Allergies", value: "allergies" },
  { _id: 15, checked: false, text: "Patient ID Number", value: "companyID" },

  { _id: 17, checked: false, text: "Department", value: "companyDepartment" },
];
export const MARKETING_CONSENT = [
  { _id: 18, checked: false, text: "SMS", value: "marketingSms" },
  { _id: 19, checked: false, text: "Email", value: "marketingEmail" },
  { _id: 20, checked: false, text: "Phone Call", value: "marketingPhoneCall" },
  { _id: 21, checked: false, text: "Whatsapp", value: "marketingWhatsapp" },
];

export const DAYS_OF_THE_WEEK = [
  { label: "Sunday", value: "sunday" },
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
];

export const APPOINTMENTS_SLOTS = Array.from({ length: 60 }, (_, id) => id + 1).map((slotValue) => ({
  label: `${slotValue} minute${slotValue === 1 ? "" : "s"}`,
  value: `${slotValue}`,
}));

export const UNIT_OF_PURCHASE_OPTIONS = [
  { label: "Bottle", value: "Bottle" },
  { label: "Box", value: "Box" },
  { label: "Cartons", value: "Cartons" },
  { label: "Case", value: "Case" },
  { label: "Cups", value: "Cups" },
  { label: "Dozen", value: "Dozen" },
  { label: "Each", value: "Each" },
  { label: "Gallon", value: "Gallon" },
  { label: "Inches", value: "Inches" },
  { label: "Oz", value: "Oz" },
  { label: "Packs", value: "Packs" },
  { label: "Sheet", value: "Sheet" },
  { label: "Yard", value: "Yard" },
];

export const PRODUCT_VARIANT_OPTIONS = [
  { label: "Colour", value: "colour" },
  { label: "Size", value: "size" },
  { label: "Shape", value: "shape" },
  { label: "Length", value: "length" },
  { label: "Gender", value: "gender" },
  { label: "Class", value: "class" },
  { label: "Adult or Kid", value: "adult or kid" },
  { label: "Type", value: "type" },
  { label: "Frame", value: "frame" },
  { label: "Material", value: "material" },
  { label: "Style", value: "style" },
  { label: "Bridge", value: "bridge" },
  { label: "Model", value: "model" },
];

export const UNIT_OF_SALES_OPTIONS = [
  { label: "Ampoules(s)", value: "Ampoules(s)" },
  { label: "Bottle(s)", value: "Bottle(s)" },
  { label: "Bag(s)", value: "Bag(s)" },
  { label: "Can(s)", value: "Can(s)" },
  { label: "Catheter", value: "Catheter" },
  { label: "Capsule(s)", value: "Capsule(s)" },
  { label: "ML(Ampoules)", value: "ML(Ampoules)" },
  { label: "ML(syrub)", value: "ML(syrub)" },
  { label: "Pessary(Capsules)", value: "Pessary(Capsules)" },
  { label: "Roll(s)", value: "Roll(s)" },
  { label: "Strip", value: "Strip" },
  { label: "Supp(Capsules)", value: "Supp(Capsules)" },
  { label: "Tablet(s)", value: "Tablet(s)" },
  { label: "Tube(s)", value: "Tube(s)" },
  { label: "Vial(s)", value: "Vial(s)" },
];

export const PATIENT_FILTER_OPTIONS = ["Name", "MRN", "Phone Number", "Email", "Department", "ID NO"];

export const DOSE_FREQUENCY_OPTIONS = [
  { label: "once a day (OD)", value: "once a day (OD)" },
  { label: "twice a day (BID)", value: "twice a day (BID)" },
  { label: "three times a day (TID)", value: "three times a day (TID)" },
  { label: "four times a day (QID)", value: "four times a day (QID)" },
  { label: "five times a day", value: "five times a day" },
  { label: "six times a day", value: "six times a day" },
  { label: "Immediately (STAT)", value: "Immediately (STAT)" },
  { label: "Every four hours (Q4H)", value: "Every four hours (Q4H)" },
  { label: "Every five hours (Q5H)", value: "Every five hours (Q5H)" },
  { label: "every six hours (Q6H)", value: "every six hours (Q6H)" },
  { label: "bedtime", value: "bedtime" },
  { label: "nocte", value: "nocte" },
  { label: "30 minutes", value: "30 minutes" },
  { label: "1 hourly", value: "1 hourly" },
  { label: "2 hourly", value: "2 hourly" },
  { label: "3 hourly", value: "3 hourly" },
  { label: "4 hourly", value: "4 hourly" },
  { label: "8 hourly", value: "8 hourly" },
  { label: "10 hourly", value: "10 hourly" },
  { label: "12 hourly", value: "12 hourly" },
];

export const DOSAGE_ROUTE_OPTIONS = [
  { label: "Mouth/oral", value: "Mouth/oral" },
  { label: "Intermuscular/Injection", value: "Intermuscular/Injection" },
  { label: "Intravenous/Injection", value: "Intravenous/Injection" },
  { label: "Intravenous Push", value: "Intravenous Push" },
  { label: "Subcutaneous", value: "Subcutaneous" },
  { label: "Rectal", value: "Rectal" },
  { label: "Vagina", value: "Vagina" },
  { label: "Nasal", value: "Nasal" },
  { label: "Intradermal", value: "Intradermal" },
  { label: "Total Parenteral nutrition", value: "Total Parenteral nutrition" },
  { label: "Nothing by mouth", value: "Nothing by mouth" },
  { label: "Sublingual", value: "Sublingual" },
  { label: "Ocular", value: "Ocular" },
  { label: "Otic", value: "Otic" },
  { label: "Inhalation", value: "Inhalation" },
  { label: "Nubulization", value: "Nubulization" },
  { label: "Cutaneous", value: "Cutaneous" },
  { label: "Transdermal", value: "Transdermal" },
];

export const DOSAGE_FORM_OPTIONS = [
  { label: "Tablets", value: "Tablets" },
  { label: "Capsules", value: "Capsules" },
  { label: "mg", value: "mg" },
  { label: "mL", value: "mL" },
  { label: "Tsp", value: "Tsp" },
  { label: "Tbsp", value: "Tbsp" },
  { label: "oz", value: "oz" },
  { label: "Microgram", value: "microgram" },
  { label: "Cup", value: "Cup" },
  { label: "Drops", value: "Drops" },
  { label: "Syrup", value: "Syrup" },
  { label: "Powder", value: "Powder" },
  { label: "Injections", value: "Injections" },
  { label: "Gel", value: "Gel" },
  { label: "FTU", value: "FTU" },
  { label: "Gram", value: "Gram" },
  { label: "IU", value: "IU" },
];

export const ROLES = [
  { value: "admin", label: "admin" },
  { value: "staff", label: "staff" },
];

export const BRANCHES = [
  { value: "ikeja", label: "ikeja" },
  { value: "lekki", label: "lekki" },
];

export const DEPARTMENTS = [
  { value: "optical", label: "optical" },
  { value: "clinical", label: "clinical" },
];

export const REFERRAL_OPTIONS = [
  { label: "Facebook", value: "Facebook" },
  { label: "LinkedIn", value: "LinkedIn" },
  { label: "Twitter", value: "Twitter" },
  { label: "Website", value: "Website" },
  { label: "Friend", value: "Friend" },
  { label: "Poster", value: "Poster" },
  { label: "Hospital Outreach Programme", value: "Hospital Outreach Programme" },
  { label: "Others", value: "Others" },
];

export const TODO = "pending";
export const PENDING = "accepted";
export const IN_PROGRESS = "active";
export const COMPLETED = "completed";
export const DISPATCHED = "dispatched";
export const DELIVERED = "delivered";
export const DECLINED = "declined";
export const RECALLED = "recalled";

export const TASK_STATUSES = /** @type {const} */ ({
  COMPLETED: "completed",
  DELIVERED: "delivered",
  DISPATCHED: "dispatched",
  PENDING: "pending",
  TODO: "todo",
  ACTIVE: "active",
  ACCEPTED: "accepted",
  DECLINED: "declined",
  RECALLED: "recalled",
});

export const ORDER_STATE_OPTIONS = [
  { label: "All", value: "" },
  { label: "Todo", value: TODO },
  { label: "Pending", value: PENDING },
  { label: "Active", value: IN_PROGRESS },
  { label: "Completed", value: COMPLETED },
  { label: "Dispatched", value: DISPATCHED },
  { label: "Declined", value: DECLINED },
];

export const RELATIONSHIP_OPTIONS = [
  { label: "Mother", value: "Mother" },
  { label: "Father", value: "Father" },
  { label: "Son", value: "Son" },
  { label: "Daughter", value: "Daughter" },
  { label: "Sibling", value: "Sibling" },
  { label: "Cousin", value: "Cousin" },
  { label: "Relation", value: "Relation" },
  { label: "Spouse", value: "Spouse" },
  { label: "Friend", value: "Friend" },
];

export const ICD_CODES = [
  { label: "ICD 9", value: "icd9" },
  { label: "ICD 10", value: "icd10" },
];

export const TIMEZONES_UTC = [
  { label: "(UTC -12:00) International Date Line West", value: "Etc/GMT+12" },
  { label: "(UTC -11:00) Coordinated Universal Time-11", value: "Pacific/Pago_Pago" },
  { label: "(UTC -10:00) Hawaii", value: "Pacific/Honolulu" },
  { label: "(UTC -09:00) Alaska", value: "America/Anchorage" },
  { label: "(UTC -08:00) Baja California, Pacific Time (US and Canada)", value: "America/Los_Angeles" },
  {
    label: "(UTC -07:00) Chihuahua, La Paz, Mazatlan, Arizona, Mountain Time (US and Canada)",
    value: "America/Denver",
  },
  {
    label:
      "(UTC -06:00) Central America, Central Time (US and Canada), Saskatchewan, Guadalajara, Mexico City, Monterey",
    value: "America/Chicago",
  },
  {
    label: "(UTC -05:00) Bogota, Lima, Quito, Indiana (East), Eastern Time (US and Canada)",
    value: "America/New_York",
  },
  { label: "(UTC -04:30) Caracas", value: "America/Caracas" },
  {
    label: "(UTC -04:00) Atlantic Time (Canada), Asuncion, Georgetown, La Paz, Manaus, San Juan, Cuiaba, Santiago",
    value: "America/Halifax",
  },
  { label: "(UTC -03:30) Newfoundland", value: "America/St_Johns" },
  {
    label: "(UTC -03:00) Brasilia, Greenland, Cayenne, Fortaleza, Buenos Aires, Montevideo",
    value: "America/Sao_Paulo",
  },
  { label: "(UTC -02:00) Coordinated Universal Time-2", value: "America/Noronha" },
  { label: "(UTC -01:00) Cape Verde, Azores", value: "Atlantic/Azores" },
  { label: "(UTC +00:00) Casablanca, Monrovia, Reykjavik, Dublin, Edinburgh, Lisbon, London", value: "Europe/London" },
  {
    label:
      "(UTC +01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, Brussels, Copenhagen, Madrid, Paris, West Central Africa, Belgrade, Bratislava, Budapest, Ljubljana, Prague, Sarajevo, Skopje, Warsaw, Zagreb, Windhoek",
    value: "Europe/Berlin",
  },
  {
    label:
      "(UTC +02:00) Athens, Bucharest, Istanbul, Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius, Cairo, Damascus, Amman, Harare, Pretoria, Jerusalem, Beirut",
    value: "Europe/Athens",
  },
  {
    label: "(UTC +03:00) Baghdad, Minsk, Kuwait, Riyadh, Nairobi",
    value: "Europe/Moscow",
  },
  { label: "(UTC +03:30) Tehran", value: "Asia/Tehran" },
  { label: "(UTC +01:00) West Central Africa - Lagos", value: "Africa/Lagos" },
  {
    label: "(UTC +04:00) Moscow, St. Petersburg, Volgograd, Tbilisi, Yerevan, Abu Dhabi, Muscat, Baku, Port Louis",
    value: "Asia/Dubai",
  },
  { label: "(UTC +04:30) Kabul", value: "Asia/Kabul" },
  { label: "(UTC +05:00) Tashkent, Islamabad, Karachi", value: "Asia/Tashkent" },
  { label: "(UTC +05:30) Sri Jayewardenepura Kotte, Chennai, Kolkata, Mumbai, New Delhi", value: "Asia/Kolkata" },
  { label: "(UTC +05:45) Kathmandu", value: "Asia/Kathmandu" },
  { label: "(UTC +06:00) Astana, Dhaka, Yekaterinburg", value: "Asia/Dhaka" },
  { label: "(UTC +06:30) Yangon", value: "Asia/Yangon" },
  { label: "(UTC +06:30) Yangon", value: "Asia/Yangon" },
  { label: "(UTC +07:00) Bangkok, Hanoi, Jakarta, Novosibirsk", value: "Asia/Bangkok" },
  {
    label:
      "(UTC +08:00) Krasnoyarsk, Ulaanbaatar, Beijing, Chongqing, Hong Kong, Urumqi, Perth, Kuala Lumpur, Singapore, Taipei",
    value: "Asia/Shanghai",
  },
  { label: "(UTC +09:00) Irkutsk, Seoul, Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
  { label: "(UTC +09:30) Darwin, Adelaide", value: "Australia/Darwin" },
  {
    label: "(UTC +10:00) Hobart, Yakutsk, Brisbane, Guam, Port Moresby, Canberra, Melbourne, Sydney",
    value: "Australia/Sydney",
  },
  { label: "(UTC +11:00) Vladivostok, Solomon Islands, New Caledonia", value: "Pacific/Noumea" },
  {
    label: "(UTC +12:00) Coordinated Universal Time+12, Fiji, Marshall Islands, Magadan, Auckland, Wellington",
    value: "Pacific/Auckland",
  },
  { label: "(UTC +13:00) Nuku'alofa, Samoa", value: "Pacific/Apia" },
];

export const REQUIRED_COMPLAINT_KEYS = [
  "rightEye",
  "leftEye",
  "historyOfPresentEye",
  "previousEyeProblems",
  "summary",
  "haveYouSortAdviceBefore",
  "otherComments",
];

export const REQUIRED_OP_CASNOTE_KEYS = [
  "complaint",
  "anteriorSegmentExam",
  "extraOcularMuscleMovement",
  "fundus",
  "pastOcularHistory",
  "posteriorSegmentExam",
  "refraction",
  "visualAcuity",
  "selectedEye",
  "leftEyeOtherDiagnosis",
  "rightEyeOtherDiagnosis",
  "leftEyeDiagnosis",
  "rightEyeDiagnosis",
  "followUp",
  "narrative",
  "attachments",
  "signedBy",
  "linkedVisit",
  "initialVisitDate",
  "procedureRecentlyCompleted",
  "recommendations",
  "findings",
  "systemicConditions",
];

export const REQUIRED_GENERAL_CASNOTE_KEYS = [
  "complaint",
  "narrative",
  "attachments",
  "signedBy",
  "linkedVisit",
  "recommendations",
  "systemReview",
  "medicalHistory",
  "physicalExamination",
  "diagnosis",
  "otherDiagnosis",
  "systemicConditions",
  "findings",
  "attachments",
  "linkedVisit",
  "initialVisitDate",
  "procedureRecentlyCompleted",
  "recommendations",
];
export const SWIPER_PARAMS = {
  containerclass: "swiper-container p-1 pb-3",
  slidesPerView: 1,
  spaceBetween: 20,
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    1600: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1330: {
      slidesPerView: 3,
      spaceBetween: 15,
    },

    1200: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
    830: {
      slidesPerView: 2.2,
      spaceBetween: 15,
    },
    650: {
      slidesPerView: 1.8,
      spaceBetween: 15,
    },
    450: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
  },
};

export const EXTRA_OCULAR_OPTIONS = [
  { label: "IOP", value: "iop" },
  { label: "IOP Adjusted", value: "adjusted" },
  { label: "Pupils", value: "pupils" },
  { label: "Orbit", value: "orbit" },
  { label: "Lids", value: "lids" },
  { label: "Conjunctiva", value: "conjunctiva" },
  { label: "Cornea", value: "cornea" },
  { label: "AC / Iris", value: "acIris" },
  { label: "Lens", value: "lens" },
  { label: "Vitreous", value: "vitreous" },
];

export const FUNDUS_OPTIONS = [
  { label: "Disc", value: "disk" },
  { label: "Vessels", value: "vessels" },
  { label: "Macular", value: "macular" },
  { label: "Periphery", value: "periphery" },
];

export const REFRACTION_OPTIONS = [
  { label: "Retinoscopy", value: "retinoscopy" },
  { label: "Subjective", value: "subjective" },
];
export const VISUAL_ACUITY_OPTIONS = [
  { label: "CC", value: "cc" },
  { label: "PH", value: "ph" },
  { label: "NEAR", value: "near" },
  { label: "SC", value: "sc" },
];

export const FILTER_OPTION = [
  { label: "Name", value: "name" },
  { label: "MRN", value: "mrn" },
  { label: "Phone Number", value: "phoneNumber" },
  { label: "Email", value: "email" },
  { label: "Department", value: "companyDepartment" },
  { label: "ID NO", value: "staffId" },
];

export const PATIENT_RELIGION = [
  { label: "Atheism", value: "Atheism" },
  { label: "Baha'i", value: "Baha'i" },
  { label: "Buddhism", value: "Buddhism" },
  { label: "Candomblé", value: "Candomblé" },
  { label: "Christianity", value: "Christianity" },
  { label: "Hinduism", value: "Hinduism" },
  { label: "Islam", value: "Islam" },
  { label: "Jainism", value: "Jainism" },
  { label: "Jehovah's Witnesses", value: "Jehovah's Witnesses" },
  { label: "Mormonism", value: "Mormonism" },
  { label: "Paganism", value: "Paganism" },
  { label: "Rastafari", value: "Rastafari" },
  { label: "Santeria", value: "Santeria" },
  { label: "Shintoism", value: "Shintoism" },
  { label: "Sikhism", value: "Sikhism" },
  { label: "Spiritualism", value: "Spiritualism" },
  { label: "Taoism", value: "Taoism" },
  { label: "Unitarianism", value: "Unitarianism" },
  { label: "Zoroastrianism", value: "Zoroastrianism" },
  { label: "Traditional beliefs", value: "Traditional beliefs" },
  { label: "Syncretic", value: "Syncretic" },
  { label: "Non-religious", value: "Non-religious" },
];

export const DESCRIBE_COMPLAINT_OPTIONS = [
  { label: "Acute", value: "Acute" },
  { label: "Chronic", value: "Chronic" },
  { label: "Subacute", value: "Subacute" },
  { label: "Worse at night", value: "Worse at night" },
  { label: "Worse during the day", value: "Worse during the day" },
  { label: "Constant", value: "Constant" },
  { label: "Intermittent ", value: "Intermittent " },
  { label: "Colicky", value: "Colicky" },
  { label: "Sharp", value: "Sharp" },
  { label: "Crushing", value: "Crushing" },
  { label: "Pressured", value: "Pressured" },
  { label: "Worse with food", value: "Worse with food" },
  { label: "Worse without food", value: "Worse without food" },
  { label: "Worse with exertion", value: "Worse with exertion" },
  { label: "Relieved at rest", value: "Relieved at rest" },
  { label: "Projectile", value: "Projectile" },
  { label: "Non Projectile", value: "Non Projectile" },
];

export const SEVERITY_COLOR = [
  { label: "None", value: "None" },
  { label: "Minor", value: "Minor" },
  { label: "Moderate", value: "Moderate" },
  { label: "Major", value: "Major" },
  { label: "Extreme", value: "Extreme" },
];

export const FORM_IDS = {
  saveVitalsForm: "saveVitalsForm",
  addCaseNoteForm: "addCaseNoteForm",
  saveComplaintForm: "saveComplaintForm",
  presentingComplaintCaseNoteForm: "presentingComplaintCaseNoteForm",
  reviewOfSystemCaseNoteForm: "reviewOfSystemCaseNoteForm",
  medicalHistoryCaseNoteForm: "medicalHistoryCaseNoteForm",
  physicalExaminationCaseNoteForm: "physicalExaminationCaseNoteForm",
  otherDiagnosisCaseNoteForm: "otherDiagnosisCaseNoteForm",
  requestLabInvestigationCaseNoteForm: "requestLabInvestigationCaseNoteForm",
  primaryDiagnosisCaseNoteForm: "physicalExaminationCaseNoteForm",
  addPrescriptionCaseNoteForm: "addPrescriptionCaseNoteForm",
  addPrescriptionCaseNoteForm2: "addPrescriptionCaseNoteForm2",
  referralForm: "referralForm",
  SaveBookSurgery: "SaveBookSurgery",
  SaveProcedure: "SaveProcedure",
  SaveProcedureInOffice: "SaveProcedure",
  SaveProcedureInternal: "SaveProcedureInternal",
  SaveProcedureExternal: "SaveProcedureExternal",
  saveAdmitPatient: "saveAdmitPatient",
  saveAppointment: "saveAppointment",
  savePrescription: "savePrescription",
  saveFollowUp: "saveFollowUp",
  addProgressNoteForm: "addProgressNoteForm",
  addPastRecordForm: "addPastRecordForm",
  addConsumablesForm: "addConsumablesForm",
  addAdmissionServices: "addAdmissionServices",
  addNursingNote: "addNursingNote",
  saveVisualAcuity: "saveVisualAcuity",
  saveReviewOfSystems: "saveReviewOfSystems",
  saveAnteriorSegmentExamination: "saveAnteriorSegmentExamination",
  savePosteriorSegmentExamination: "savePosteriorSegmentExamination",
  saveFundus: "saveFundus",
  saveExtraOcularMuscleMovement: "saveExtraOcularMuscleMovement",
  savePastOcularHistory: "savePastOcularHistory",
  counselorsForm: "counselorsForm",
  patientSurgeryChecklist: "patientSurgeryChecklist",
  operationRoomChecklist: "operationRoomChecklist",
  preOperativeFormIntraOperative: "preOperativeFormIntraOperative",
  anesthesiaRecords: "anesthesiaRecords",
  generalOperationForm: "generalOperationForm",
  postOperativeForm: "postOperativeForm",
};

export const SURGERY_LOCATIONS = [
  { label: "Theatre", value: "theatre" },
  { label: "In Office", value: "inOffice" },
];

export const CUSTOM_ERROR_MESSAGE = "Oops something went wrong";

export const SOCKET_EVENTS = [
  {
    title: "New Appointment",
    event: "newAppointment",
  },
  {
    title: "Vitals Done",
    event: "newConsultingAppointment",
  },
  {
    title: "Patient Accepted",
    event: "patientAccepted",
  },
  {
    title: "Lab Tests Requested",
    event: "labStatus",
  },
  {
    title: "Lab Task Recalled",
    event: "taskRecalled",
  },
  {
    title: "Investigation Requested",
    event: "newInvestigation",
  },
  {
    title: "New Task Assigned",
    event: "taskAssigned",
  },
  {
    title: "New Reply on Task",
    event: "commentReply",
  },
  {
    title: "New Mention on Task",
    event: "commentMention",
  },
  {
    title: "Task Due Soon Reminder",
    event: "taskReminder",
  },
  {
    title: "Procedure Requested",
    event: "newProcedure",
  },
  {
    title: "New Prescription",
    event: "newPrescription",
  },
  {
    title: "Billing Updated",
    event: "billUpdated",
  },
  {
    title: "Cart Updated",
    event: "cartUpdated",
  },
  {
    title: "Private Patient Admitted",
    event: "newAdmission",
  },
  {
    title: "Test Result",
    event: "testTypeResult",
  },
  {
    title: "Consultant Transfer",
    event: "consultantTransfer",
  },
  {
    title: "Release Notes",
    event: "release-notes",
  },
  {
    title: "Lab Tracking Activated",
    event: "labTrackingActivated",
  },
  {
    title: "Lab Tracking Deactivated",
    event: "labTrackingDeactivated",
  },
  {
    title: "Partnership",
    event: "partnership",
  },
];

export const EDITOR_TOOLBAR = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "fontFamily",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    "embedded",
    "emoji",
    "image",
    "remove",
    "history",
  ],
  inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["bold", "italic", "underline", "strikethrough", "monospace", "superscript", "subscript"],
    // bold: { icon: bold, className: undefined },
    // italic: { icon: italic, className: undefined },
    // underline: { icon: underline, className: undefined },
    // strikethrough: { icon: strikethrough, className: undefined },
    // monospace: { icon: monospace, className: undefined },
    // superscript: { icon: superscript, className: undefined },
    // subscript: { icon: subscript, className: undefined },
  },
  blockType: {
    inDropdown: true,
    options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote", "Code"],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  fontSize: {
    icon: undefined,
    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  fontFamily: {
    options: ["Arial", "Georgia", "Impact", "Tahoma", "Times New Roman", "Verdana"],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  list: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["unordered", "ordered", "indent", "outdent"],
    // unordered: { icon: unordered, className: undefined },
    // ordered: { icon: ordered, className: undefined },
    // indent: { icon: indent, className: undefined },
    // outdent: { icon: outdent, className: undefined },
  },
  textAlign: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["left", "center", "right", "justify"],
    // left: { icon: left, className: undefined },
    // center: { icon: center, className: undefined },
    // right: { icon: right, className: undefined },
    // justify: { icon: justify, className: undefined },
  },
  colorPicker: {
    icon: undefined,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    colors: [
      "rgb(97,189,109)",
      "rgb(26,188,156)",
      "rgb(84,172,210)",
      "rgb(44,130,201)",
      "rgb(147,101,184)",
      "rgb(71,85,119)",
      "rgb(204,204,204)",
      "rgb(65,168,95)",
      "rgb(0,168,133)",
      "rgb(61,142,185)",
      "rgb(41,105,176)",
      "rgb(85,57,130)",
      "rgb(40,50,78)",
      "rgb(0,0,0)",
      "rgb(247,218,100)",
      "rgb(251,160,38)",
      "rgb(235,107,86)",
      "rgb(226,80,65)",
      "rgb(163,143,132)",
      "rgb(239,239,239)",
      "rgb(255,255,255)",
      "rgb(250,197,28)",
      "rgb(243,121,52)",
      "rgb(209,72,65)",
      "rgb(184,49,47)",
      "rgb(124,112,107)",
      "rgb(209,213,216)",
    ],
  },
  link: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    dropdownClassName: undefined,
    showOpenOptionOnHover: true,
    defaultTargetOption: "_self",
    options: ["link", "unlink"],
    // link: { icon: link, className: undefined },
    // unlink: { icon: unlink, className: undefined },
    linkCallback: undefined,
  },
  emoji: {
    // icon: emoji,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    emojis: [
      "😀",
      "😁",
      "😂",
      "😃",
      "😉",
      "😋",
      "😎",
      "😍",
      "😗",
      "🤗",
      "🤔",
      "😣",
      "😫",
      "😴",
      "😌",
      "🤓",
      "😛",
      "😜",
      "😠",
      "😇",
      "😷",
      "😈",
      "👻",
      "😺",
      "😸",
      "😹",
      "😻",
      "😼",
      "😽",
      "🙀",
      "🙈",
      "🙉",
      "🙊",
      "👼",
      "👮",
      "🕵",
      "💂",
      "👳",
      "🎅",
      "👸",
      "👰",
      "👲",
      "🙍",
      "🙇",
      "🚶",
      "🏃",
      "💃",
      "⛷",
      "🏂",
      "🏌",
      "🏄",
      "🚣",
      "🏊",
      "⛹",
      "🏋",
      "🚴",
      "👫",
      "💪",
      "👈",
      "👉",
      "👉",
      "👆",
      "🖕",
      "👇",
      "🖖",
      "🤘",
      "🖐",
      "👌",
      "👍",
      "👎",
      "✊",
      "👊",
      "👏",
      "🙌",
      "🙏",
      "🐵",
      "🐶",
      "🐇",
      "🐥",
      "🐸",
      "🐌",
      "🐛",
      "🐜",
      "🐝",
      "🍉",
      "🍄",
      "🍔",
      "🍤",
      "🍨",
      "🍪",
      "🎂",
      "🍰",
      "🍾",
      "🍷",
      "🍸",
      "🍺",
      "🌍",
      "🚑",
      "⏰",
      "🌙",
      "🌝",
      "🌞",
      "⭐",
      "🌟",
      "🌠",
      "🌨",
      "🌩",
      "⛄",
      "🔥",
      "🎄",
      "🎈",
      "🎉",
      "🎊",
      "🎁",
      "🎗",
      "🏀",
      "🏈",
      "🎲",
      "🔇",
      "🔈",
      "📣",
      "🔔",
      "🎵",
      "🎷",
      "💰",
      "🖊",
      "📅",
      "✅",
      "❎",
      "💯",
    ],
  },
  embedded: {
    // icon: embedded,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    embedCallback: undefined,
    defaultSize: {
      height: "auto",
      width: "auto",
    },
  },
  image: {
    // icon: image,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: true,
    uploadCallback: undefined,
    previewImage: false,
    inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
    alt: { present: false, mandatory: false },
    defaultSize: {
      height: "auto",
      width: "auto",
    },
  },
  remove: {
    // icon: eraser,
    className: undefined,
    component: undefined,
  },
  history: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["undo", "redo"],
    // undo: { icon: undo, className: undefined },
    // redo: { icon: redo, className: undefined },
  },
};

export const MEDICAL_RECORD_MODELS = {
  WardRound: "WardRound",
  NursingNote: "NursingNote",
  RxPrescription: "RxPrescription",
  Procedure: "Procedure",
  ProgressNote: "ProgressNote",
  CaseNotes: "CaseNotes",
  MedicalReferral: "MedicalReferral",
  Vital: "Vital",
  Investigation: "Investigation",
  Assessment: "Assessment",
  ContinuousAssessment: "ContinuousAssessment",
  SoapNote: "SoapNote",
  Observation: "Observation",
  FluidBalance: "FluidBalance",
  IVFluid: "IVFluid",
  ConsentForm: "ConsentForm",
  Surgery: "Surgery",
  FormEntry: "FormEntry",
};

export const MEDICAL_RECORD_MODELS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Ward Round", value: "WardRound" },
  { label: "Nursing Note", value: "NursingNote" },
  { label: "Prescription", value: "RxPrescription" },
  { label: "Procedure", value: "Procedure" },
  { label: "Progress Note", value: "ProgressNote" },
  { label: "Case Notes", value: "CaseNotes" },
  { label: "Medical Referral", value: "MedicalReferral" },
  { label: "Vital", value: "Vital" },
  { label: "Investigation", value: "Investigation" },
  { label: "Assessment", value: "Assessment" },
  { label: "Continuous Assessment", value: "ContinuousAssessment" },
  { label: "Soap Note", value: "SoapNote" },
  { label: "Observation", value: "Observation" },
  { label: "Fluid Balance", value: "FluidBalance" },
  { label: "IV Fluid", value: "IVFluid" },
  { label: "Consent Form", value: "ConsentForm" },
  { label: "Surgery", value: "Surgery" },
  { label: "Custom Form", value: "FormEntry" },
];

export const COUNTRIES = [
  {
    continent: "Asia",
    region: "South Asia",
    country: "Afghanistan",
    capital: "Kabul",
    fips: "AF",
    iso2: "AF",
    currency: "AFN",
    iso3: "AFG",
    isoNo: "004",
    internet: "AF",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Albania",
    capital: "Tirana",
    fips: "AL",
    iso2: "AL",
    currency: "ALL",
    iso3: "ALB",
    isoNo: "008",
    internet: "AL",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Algeria",
    capital: "Algiers",
    fips: "AG",
    iso2: "DZ",
    currency: "DZD",
    iso3: "DZA",
    isoNo: "012",
    internet: "DZ",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "American Samoa",
    capital: "Pago Pago",
    fips: "AQ",
    iso2: "AS",
    currency: "USD",
    iso3: "ASM",
    isoNo: "016",
    internet: "AS",
  },
  {
    continent: "Europe",
    region: "South West Europe",
    country: "Andorra",
    capital: "Andorra la Vella",
    fips: "AN",
    iso2: "AD",
    currency: "EUR",
    iso3: "AND",
    isoNo: "020",
    internet: "AD",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Angola",
    capital: "Luanda",
    fips: "AO",
    iso2: "AO",
    currency: "AOA",
    iso3: "AGO",
    isoNo: "024",
    internet: "AO",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Anguilla",
    capital: "The Valley",
    fips: "AV",
    iso2: "AI",
    currency: "XCD",
    iso3: "AIA",
    isoNo: "660",
    internet: "AI",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Antigua and Barbuda",
    capital: "Saint John's",
    fips: "AC",
    iso2: "AG",
    currency: "XCD",
    iso3: "ATG",
    isoNo: "028",
    internet: "AG",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Argentina",
    capital: "Buenos Aires",
    fips: "AR",
    iso2: "AR",
    currency: "ARS",
    iso3: "ARG",
    isoNo: "032",
    internet: "AR",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Armenia",
    capital: "Yerevan",
    fips: "AM",
    iso2: "AM",
    currency: "AMD",
    iso3: "ARM",
    isoNo: "051",
    internet: "AM",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Aruba",
    capital: "Oranjestad",
    fips: "AA",
    iso2: "AW",
    currency: "AWG",
    iso3: "ABW",
    isoNo: "533",
    internet: "AW",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Australia",
    capital: "Canberra",
    fips: "AS",
    iso2: "AU",
    currency: "AUD",
    iso3: "AUS",
    isoNo: "036",
    internet: "AU",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Austria",
    capital: "Vienna",
    fips: "AU",
    iso2: "AT",
    currency: "EUR",
    iso3: "AUT",
    isoNo: "040",
    internet: "AT",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Azerbaijan",
    capital: "Baku (Baki)",
    fips: "AJ",
    iso2: "AZ",
    currency: "AZN",
    iso3: "AZE",
    isoNo: "031",
    internet: "AZ",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "The Bahamas",
    capital: "Nassau",
    fips: "BF",
    iso2: "BS",
    currency: "BSD",
    iso3: "BHS",
    isoNo: "044",
    internet: "BS",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Bahrain",
    capital: "Manama",
    fips: "BA",
    iso2: "BH",
    currency: "BHD",
    iso3: "BHR",
    isoNo: "048",
    internet: "BH",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Bangladesh",
    capital: "Dhaka",
    fips: "BG",
    iso2: "BD",
    currency: "BDT",
    iso3: "BGD",
    isoNo: "050",
    internet: "BD",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Barbados",
    capital: "Bridgetown",
    fips: "BB",
    iso2: "BB",
    currency: "BBD",
    iso3: "BRB",
    isoNo: "052",
    internet: "BB",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Belarus",
    capital: "Minsk",
    fips: "BO",
    iso2: "BY",
    currency: "BYN",
    iso3: "BLR",
    isoNo: "112",
    internet: "BY",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Belgium",
    capital: "Brussels",
    fips: "BE",
    iso2: "BE",
    currency: "EUR",
    iso3: "BEL",
    isoNo: "056",
    internet: "BE",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Belize",
    capital: "Belmopan",
    fips: "BH",
    iso2: "BZ",
    currency: "BZD",
    iso3: "BLZ",
    isoNo: "084",
    internet: "BZ",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Benin",
    capital: "Porto-Novo",
    fips: "BN",
    iso2: "BJ",
    currency: "XOF",
    iso3: "BEN",
    isoNo: "204",
    internet: "BJ",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Bermuda",
    capital: "Hamilton",
    fips: "BD",
    iso2: "BM",
    currency: "BMD",
    iso3: "BMU",
    isoNo: "060",
    internet: "BM",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Bhutan",
    capital: "Thimphu",
    fips: "BT",
    iso2: "BT",
    currency: "BTN",
    iso3: "BTN",
    isoNo: "064",
    internet: "BT",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Bolivia",
    capital: "La Paz / Sucre",
    fips: "BL",
    iso2: "BO",
    currency: "BOB",
    iso3: "BOL",
    isoNo: "068",
    internet: "BO",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Bosnia and Herzegovina",
    capital: "Sarajevo",
    fips: "BK",
    iso2: "BA",
    currency: "BAM",
    iso3: "BIH",
    isoNo: "070",
    internet: "BA",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Botswana",
    capital: "Gaborone",
    fips: "BC",
    iso2: "BW",
    currency: "BWP",
    iso3: "BWA",
    isoNo: "072",
    internet: "BW",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Brazil",
    capital: "Brasilia",
    fips: "BR",
    iso2: "BR",
    currency: "BRL",
    iso3: "BRA",
    isoNo: "076",
    internet: "BR",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "British Virgin Islands",
    capital: "Road Town",
    fips: "VI",
    iso2: "VG",
    currency: "USD",
    iso3: "VGB",
    isoNo: "092",
    internet: "VG",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Brunei",
    capital: "Bandar Seri Begawan",
    fips: "BX",
    iso2: "BN",
    currency: "BND",
    iso3: "BRN",
    isoNo: "096",
    internet: "BN",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Bulgaria",
    capital: "Sofia",
    fips: "BU",
    iso2: "BG",
    currency: "BGN",
    iso3: "BGR",
    isoNo: "100",
    internet: "BG",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Burkina Faso",
    capital: "Ouagadougou",
    fips: "UV",
    iso2: "BF",
    currency: "XOF",
    iso3: "BFA",
    isoNo: "854",
    internet: "BF",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Burundi",
    capital: "Bujumbura",
    fips: "BY",
    iso2: "BI",
    currency: "BIF",
    iso3: "BDI",
    isoNo: "108",
    internet: "BI",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Cambodia",
    capital: "Phnom Penh",
    fips: "CB",
    iso2: "KH",
    currency: "KHR",
    iso3: "KHM",
    isoNo: "116",
    internet: "KH",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Cameroon",
    capital: "Yaounde",
    fips: "CM",
    iso2: "CM",
    currency: "XAF",
    iso3: "CMR",
    isoNo: "120",
    internet: "CM",
  },
  {
    continent: "Americas",
    region: "North America",
    country: "Canada",
    capital: "Ottawa",
    fips: "CA",
    iso2: "CA",
    currency: "CAD",
    iso3: "CAN",
    isoNo: "124",
    internet: "CA",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Cape Verde",
    capital: "Praia",
    fips: "CV",
    iso2: "CV",
    currency: "CVE",
    iso3: "CPV",
    isoNo: "132",
    internet: "CV",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Cayman Islands",
    capital: "George Town",
    fips: "CJ",
    iso2: "KY",
    currency: "KYD",
    iso3: "CYM",
    isoNo: "136",
    internet: "KY",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Central African Republic",
    capital: "Bangui",
    fips: "CT",
    iso2: "CF",
    currency: "XAF",
    iso3: "CAF",
    isoNo: "140",
    internet: "CF",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Chad",
    capital: "N'Djamena",
    fips: "CD",
    iso2: "TD",
    currency: "XAF",
    iso3: "TCD",
    isoNo: "148",
    internet: "TD",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Chile",
    capital: "Santiago",
    fips: "CI",
    iso2: "CL",
    currency: "CLP",
    iso3: "CHL",
    isoNo: "152",
    internet: "CL",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "China",
    capital: "Beijing",
    fips: "CH",
    iso2: "CN",
    currency: "CNY",
    iso3: "CHN",
    isoNo: "156",
    internet: "CN",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Christmas Island",
    capital: "The Settlement",
    fips: "KT",
    iso2: "CX",
    currency: "AUD",
    iso3: "CXR",
    isoNo: "162",
    internet: "CX",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Cocos (Keeling) Islands",
    capital: "West Island",
    fips: "CK",
    iso2: "CC",
    currency: "AUD",
    iso3: "CCK",
    isoNo: "166",
    internet: "CC",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Colombia",
    capital: "Bogota",
    fips: "CO",
    iso2: "CO",
    currency: "COP",
    iso3: "COL",
    isoNo: "170",
    internet: "CO",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Comoros",
    capital: "Moroni",
    fips: "CN",
    iso2: "KM",
    currency: "KMF",
    iso3: "COM",
    isoNo: "174",
    internet: "KM",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Republic of the Congo",
    capital: "Brazzaville",
    fips: "CF",
    iso2: "CG",
    currency: "XAF",
    iso3: "COG",
    isoNo: "178",
    internet: "CG",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Cook Islands",
    capital: "Avarua",
    fips: "CW",
    iso2: "CK",
    currency: "NZD",
    iso3: "COK",
    isoNo: "184",
    internet: "CK",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Costa Rica",
    capital: "San Jose",
    fips: "CS",
    iso2: "CR",
    currency: "CRC",
    iso3: "CRI",
    isoNo: "188",
    internet: "CR",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Cote d'Ivoire",
    capital: "Yamoussoukro",
    fips: "IV",
    iso2: "CI",
    currency: "XOF",
    iso3: "CIV",
    isoNo: "384",
    internet: "CI",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Croatia",
    capital: "Zagreb",
    fips: "HR",
    iso2: "HR",
    currency: "HRK",
    iso3: "HRV",
    isoNo: "191",
    internet: "HR",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Cuba",
    capital: "Havana",
    fips: "CU",
    iso2: "CU",
    currency: "CUP",
    iso3: "CUB",
    isoNo: "192",
    internet: "CU",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Cyprus",
    capital: "Nicosia",
    fips: "CY",
    iso2: "CY",
    currency: "EUR",
    iso3: "CYP",
    isoNo: "196",
    internet: "CY",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Czechia",
    capital: "Prague",
    fips: "EZ",
    iso2: "CZ",
    currency: "CZK",
    iso3: "CZE",
    isoNo: "203",
    internet: "CZ",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Denmark",
    capital: "Copenhagen",
    fips: "DA",
    iso2: "DK",
    currency: "DKK",
    iso3: "DNK",
    isoNo: "208",
    internet: "DK",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Djibouti",
    capital: "Djibouti",
    fips: "DJ",
    iso2: "DJ",
    currency: "DJF",
    iso3: "DJI",
    isoNo: "262",
    internet: "DJ",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Dominica",
    capital: "Roseau",
    fips: "DO",
    iso2: "DM",
    currency: "XCD",
    iso3: "DMA",
    isoNo: "212",
    internet: "DM",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Dominican Republic",
    capital: "Santo Domingo",
    fips: "DR",
    iso2: "DO",
    currency: "DOP",
    iso3: "DOM",
    isoNo: "214",
    internet: "DO",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Ecuador",
    capital: "Quito",
    fips: "EC",
    iso2: "EC",
    currency: "USD",
    iso3: "ECU",
    isoNo: "218",
    internet: "EC",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Egypt",
    capital: "Cairo",
    fips: "EG",
    iso2: "EG",
    currency: "EGP",
    iso3: "EGY",
    isoNo: "818",
    internet: "EG",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "El Salvador",
    capital: "San Salvador",
    fips: "ES",
    iso2: "SV",
    currency: "USD",
    iso3: "SLV",
    isoNo: "222",
    internet: "SV",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Equatorial Guinea",
    capital: "Malabo",
    fips: "EK",
    iso2: "GQ",
    currency: "XAF",
    iso3: "GNQ",
    isoNo: "226",
    internet: "GQ",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Eritrea",
    capital: "Asmara",
    fips: "ER",
    iso2: "ER",
    currency: "ERN",
    iso3: "ERI",
    isoNo: "232",
    internet: "ER",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Estonia",
    capital: "Tallinn",
    fips: "EN",
    iso2: "EE",
    currency: "EUR",
    iso3: "EST",
    isoNo: "233",
    internet: "EE",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Ethiopia",
    capital: "Addis Ababa",
    fips: "ET",
    iso2: "ET",
    currency: "ETB",
    iso3: "ETH",
    isoNo: "231",
    internet: "ET",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Falkland Islands (Islas Malvinas)",
    capital: "Stanley",
    fips: "FA",
    iso2: "FK",
    currency: "FKP",
    iso3: "FLK",
    isoNo: "238",
    internet: "FK",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Faroe Islands",
    capital: "Torshavn",
    fips: "FO",
    iso2: "FO",
    currency: "DKK",
    iso3: "FRO",
    isoNo: "234",
    internet: "FO",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Fiji",
    capital: "Suva",
    fips: "FJ",
    iso2: "FJ",
    currency: "FJD",
    iso3: "FJI",
    isoNo: "242",
    internet: "FJ",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Finland",
    capital: "Helsinki",
    fips: "FI",
    iso2: "FI",
    currency: "EUR",
    iso3: "FIN",
    isoNo: "246",
    internet: "FI",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "France",
    capital: "Paris",
    fips: "FR",
    iso2: "FR",
    currency: "EUR",
    iso3: "FRA",
    isoNo: "250",
    internet: "FR",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "French Guiana",
    capital: "Cayenne",
    fips: "FG",
    iso2: "GF",
    currency: "EUR",
    iso3: "GUF",
    isoNo: "254",
    internet: "GF",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "French Polynesia",
    capital: "Papeete",
    fips: "FP",
    iso2: "PF",
    currency: "XPF",
    iso3: "PYF",
    isoNo: "258",
    internet: "PF",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Gabon",
    capital: "Libreville",
    fips: "GB",
    iso2: "GA",
    currency: "XAF",
    iso3: "GAB",
    isoNo: "266",
    internet: "GA",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "The Gambia",
    capital: "Banjul",
    fips: "GA",
    iso2: "GM",
    currency: "GMD",
    iso3: "GMB",
    isoNo: "270",
    internet: "GM",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Georgia",
    capital: "T'bilisi",
    fips: "GG",
    iso2: "GE",
    currency: "GEL",
    iso3: "GEO",
    isoNo: "268",
    internet: "GE",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Germany",
    capital: "Berlin",
    fips: "GM",
    iso2: "DE",
    currency: "EUR",
    iso3: "DEU",
    isoNo: "276",
    internet: "DE",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Ghana",
    capital: "Accra",
    fips: "GH",
    iso2: "GH",
    currency: "GHS",
    iso3: "GHA",
    isoNo: "288",
    internet: "GH",
  },
  {
    continent: "Europe",
    region: "South West Europe",
    country: "Gibraltar",
    capital: "Gibraltar",
    fips: "GI",
    iso2: "GI",
    currency: "GIP",
    iso3: "GIB",
    isoNo: "292",
    internet: "GI",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Greece",
    capital: "Athens",
    fips: "GR",
    iso2: "GR",
    currency: "EUR",
    iso3: "GRC",
    isoNo: "300",
    internet: "GR",
  },
  {
    continent: "Americas",
    region: "North America",
    country: "Greenland",
    capital: "Nuuk (Godthab)",
    fips: "GL",
    iso2: "GL",
    currency: "DKK",
    iso3: "GRL",
    isoNo: "304",
    internet: "GL",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Grenada",
    capital: "Saint George's",
    fips: "GJ",
    iso2: "GD",
    currency: "XCD",
    iso3: "GRD",
    isoNo: "308",
    internet: "GD",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Guadeloupe",
    capital: "Basse-Terre",
    fips: "GP",
    iso2: "GP",
    currency: "EUR",
    iso3: "GLP",
    isoNo: "312",
    internet: "GP",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Guam",
    capital: "Hagatna (Agana)",
    fips: "GQ",
    iso2: "GU",
    currency: "USD",
    iso3: "GUM",
    isoNo: "316",
    internet: "GU",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Guatemala",
    capital: "Guatemala",
    fips: "GT",
    iso2: "GT",
    currency: "GTQ",
    iso3: "GTM",
    isoNo: "320",
    internet: "GT",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Guinea",
    capital: "Conakry",
    fips: "GV",
    iso2: "GN",
    currency: "GNF",
    iso3: "GIN",
    isoNo: "324",
    internet: "GN",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Guinea-Bissau",
    capital: "Bissau",
    fips: "PU",
    iso2: "GW",
    currency: "XOF",
    iso3: "GNB",
    isoNo: "624",
    internet: "GW",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Guyana",
    capital: "Georgetown",
    fips: "GY",
    iso2: "GY",
    currency: "GYD",
    iso3: "GUY",
    isoNo: "328",
    internet: "GY",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Haiti",
    capital: "Port-au-Prince",
    fips: "HA",
    iso2: "HT",
    currency: "HTG",
    iso3: "HTI",
    isoNo: "332",
    internet: "HT",
  },
  {
    continent: "Europe",
    region: "Southern Europe",
    country: "Holy See (Vatican City)",
    capital: "Vatican City",
    fips: "VT",
    iso2: "VA",
    currency: "EUR",
    iso3: "VAT",
    isoNo: "336",
    internet: "VA",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Honduras",
    capital: "Tegucigalpa",
    fips: "HO",
    iso2: "HN",
    currency: "HNL",
    iso3: "HND",
    isoNo: "340",
    internet: "HN",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Hungary",
    capital: "Budapest",
    fips: "HU",
    iso2: "HU",
    currency: "HUF",
    iso3: "HUN",
    isoNo: "348",
    internet: "HU",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Iceland",
    capital: "Reykjavik",
    fips: "IC",
    iso2: "IS",
    currency: "ISK",
    iso3: "ISL",
    isoNo: "352",
    internet: "IS",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "India",
    capital: "New Delhi",
    fips: "IN",
    iso2: "IN",
    currency: "INR",
    iso3: "IND",
    isoNo: "356",
    internet: "IN",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Indonesia",
    capital: "Jakarta",
    fips: "ID",
    iso2: "ID",
    currency: "IDR",
    iso3: "IDN",
    isoNo: "360",
    internet: "ID",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Iran",
    capital: "Tehran",
    fips: "IR",
    iso2: "IR",
    currency: "IRR",
    iso3: "IRN",
    isoNo: "364",
    internet: "IR",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Iraq",
    capital: "Baghdad",
    fips: "IZ",
    iso2: "IQ",
    currency: "IQD",
    iso3: "IRQ",
    isoNo: "368",
    internet: "IQ",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Ireland",
    capital: "Dublin",
    fips: "EI",
    iso2: "IE",
    currency: "EUR",
    iso3: "IRL",
    isoNo: "372",
    internet: "IE",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Israel",
    capital: "Jerusalem",
    fips: "IS",
    iso2: "IL",
    currency: "ILS",
    iso3: "ISR",
    isoNo: "376",
    internet: "IL",
  },
  {
    continent: "Europe",
    region: "Southern Europe",
    country: "Italy",
    capital: "Rome",
    fips: "IT",
    iso2: "IT",
    currency: "EUR",
    iso3: "ITA",
    isoNo: "380",
    internet: "IT",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Jamaica",
    capital: "Kingston",
    fips: "JM",
    iso2: "JM",
    currency: "JMD",
    iso3: "JAM",
    isoNo: "388",
    internet: "JM",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "Japan",
    capital: "Tokyo",
    fips: "JA",
    iso2: "JP",
    currency: "JPY",
    iso3: "JPN",
    isoNo: "392",
    internet: "JP",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Jordan",
    capital: "Amman",
    fips: "JO",
    iso2: "JO",
    currency: "JOD",
    iso3: "JOR",
    isoNo: "400",
    internet: "JO",
  },
  {
    continent: "Asia",
    region: "Central Asia",
    country: "Kazakhstan",
    capital: "Astana (Akmola)",
    fips: "KZ",
    iso2: "KZ",
    currency: "KZT",
    iso3: "KAZ",
    isoNo: "398",
    internet: "KZ",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Kenya",
    capital: "Nairobi",
    fips: "KE",
    iso2: "KE",
    currency: "KES",
    iso3: "KEN",
    isoNo: "404",
    internet: "KE",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Kiribati",
    capital: "Tarawa",
    fips: "KR",
    iso2: "KI",
    currency: "AUD",
    iso3: "KIR",
    isoNo: "296",
    internet: "KI",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "North Korea",
    capital: "P'yongyang",
    fips: "KN",
    iso2: "KP",
    currency: "KPW",
    iso3: "PRK",
    isoNo: "408",
    internet: "KP",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "South Korea",
    capital: "Seoul",
    fips: "KS",
    iso2: "KR",
    currency: "KRW",
    iso3: "KOR",
    isoNo: "410",
    internet: "KR",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Kuwait",
    capital: "Kuwait",
    fips: "KU",
    iso2: "KW",
    currency: "KWD",
    iso3: "KWT",
    isoNo: "414",
    internet: "KW",
  },
  {
    continent: "Asia",
    region: "Central Asia",
    country: "Kyrgyzstan",
    capital: "Bishkek",
    fips: "KG",
    iso2: "KG",
    currency: "KGS",
    iso3: "KGZ",
    isoNo: "417",
    internet: "KG",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Laos",
    capital: "Vientiane",
    fips: "LA",
    iso2: "LA",
    currency: "LAK",
    iso3: "LAO",
    isoNo: "418",
    internet: "LA",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Latvia",
    capital: "Riga",
    fips: "LG",
    iso2: "LV",
    currency: "EUR",
    iso3: "LVA",
    isoNo: "428",
    internet: "LV",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Lebanon",
    capital: "Beirut",
    fips: "LE",
    iso2: "LB",
    currency: "LBP",
    iso3: "LBN",
    isoNo: "422",
    internet: "LB",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Lesotho",
    capital: "Maseru",
    fips: "LT",
    iso2: "LS",
    currency: "LSL",
    iso3: "LSO",
    isoNo: "426",
    internet: "LS",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Liberia",
    capital: "Monrovia",
    fips: "LI",
    iso2: "LR",
    currency: "LRD",
    iso3: "LBR",
    isoNo: "430",
    internet: "LR",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Libya",
    capital: "Tripoli",
    fips: "LY",
    iso2: "LY",
    currency: "LYD",
    iso3: "LBY",
    isoNo: "434",
    internet: "LY",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Liechtenstein",
    capital: "Vaduz",
    fips: "LS",
    iso2: "LI",
    currency: "CHF",
    iso3: "LIE",
    isoNo: "438",
    internet: "LI",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Lithuania",
    capital: "Vilnius",
    fips: "LH",
    iso2: "LT",
    currency: "EUR",
    iso3: "LTU",
    isoNo: "440",
    internet: "LT",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Luxembourg",
    capital: "Luxembourg",
    fips: "LU",
    iso2: "LU",
    currency: "EUR",
    iso3: "LUX",
    isoNo: "442",
    internet: "LU",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "North Macedonia",
    capital: "Skopje",
    fips: "MK",
    iso2: "MK",
    currency: "MKD",
    iso3: "MKD",
    isoNo: "807",
    internet: "MK",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Madagascar",
    capital: "Antananarivo",
    fips: "MA",
    iso2: "MG",
    currency: "MGA",
    iso3: "MDG",
    isoNo: "450",
    internet: "MG",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Malawi",
    capital: "Lilongwe",
    fips: "MI",
    iso2: "MW",
    currency: "MWK",
    iso3: "MWI",
    isoNo: "454",
    internet: "MW",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Malaysia",
    capital: "Kuala Lumpur",
    fips: "MY",
    iso2: "MY",
    currency: "MYR",
    iso3: "MYS",
    isoNo: "458",
    internet: "MY",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Maldives",
    capital: "Male (Maale)",
    fips: "MV",
    iso2: "MV",
    currency: "MVR",
    iso3: "MDV",
    isoNo: "462",
    internet: "MV",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Mali",
    capital: "Bamako",
    fips: "ML",
    iso2: "ML",
    currency: "XOF",
    iso3: "MLI",
    isoNo: "466",
    internet: "ML",
  },
  {
    continent: "Europe",
    region: "Southern Europe",
    country: "Malta",
    capital: "Valletta",
    fips: "MT",
    iso2: "MT",
    currency: "EUR",
    iso3: "MLT",
    isoNo: "470",
    internet: "MT",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Isle of Man",
    capital: "Douglas",
    fips: "IM",
    iso2: "IM",
    currency: "GBP",
    iso3: "IMN",
    isoNo: "833",
    internet: "IM",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Marshall Islands",
    capital: "Majuro",
    fips: "RM",
    iso2: "MH",
    currency: "USD",
    iso3: "MHL",
    isoNo: "584",
    internet: "MH",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Martinique",
    capital: "Fort-de-France",
    fips: "MB",
    iso2: "MQ",
    currency: "EUR",
    iso3: "MTQ",
    isoNo: "474",
    internet: "MQ",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Mauritania",
    capital: "Nouakchott",
    fips: "MR",
    iso2: "MR",
    currency: "MRO",
    iso3: "MRT",
    isoNo: "478",
    internet: "MR",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Mauritius",
    capital: "Port Louis",
    fips: "MP",
    iso2: "MU",
    currency: "MUR",
    iso3: "MUS",
    isoNo: "480",
    internet: "MU",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Mayotte",
    capital: "Mamoutzou",
    fips: "MF",
    iso2: "YT",
    currency: "EUR",
    iso3: "MYT",
    isoNo: "175",
    internet: "YT",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Mexico",
    capital: "Mexico",
    fips: "MX",
    iso2: "MX",
    currency: "MXN",
    iso3: "MEX",
    isoNo: "484",
    internet: "MX",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Federated States of Micronesia",
    capital: "Palikir",
    fips: "",
    iso2: "FM",
    currency: "USD",
    iso3: "FSM",
    isoNo: "583",
    internet: "FM",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Moldova",
    capital: "Chisinau",
    fips: "MD",
    iso2: "MD",
    currency: "MDL",
    iso3: "MDA",
    isoNo: "498",
    internet: "MD",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Monaco",
    capital: "Monaco",
    fips: "MN",
    iso2: "MC",
    currency: "EUR",
    iso3: "MCO",
    isoNo: "492",
    internet: "MC",
  },
  {
    continent: "Asia",
    region: "Northern Asia",
    country: "Mongolia",
    capital: "Ulaanbaatar",
    fips: "MG",
    iso2: "MN",
    currency: "MNT",
    iso3: "MNG",
    isoNo: "496",
    internet: "MN",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Montserrat",
    capital: "Plymouth",
    fips: "MH",
    iso2: "MS",
    currency: "XCD",
    iso3: "MSR",
    isoNo: "500",
    internet: "MS",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Morocco",
    capital: "Rabat",
    fips: "MO",
    iso2: "MA",
    currency: "MAD",
    iso3: "MAR",
    isoNo: "504",
    internet: "MA",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Mozambique",
    capital: "Maputo",
    fips: "MZ",
    iso2: "MZ",
    currency: "MZN",
    iso3: "MOZ",
    isoNo: "508",
    internet: "MZ",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Myanmar (Burma)",
    capital: "Rangoon (Yangon)",
    fips: "BM",
    iso2: "MM",
    currency: "MMK",
    iso3: "MMR",
    isoNo: "104",
    internet: "MM",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Namibia",
    capital: "Windhoek",
    fips: "WA",
    iso2: "NA",
    currency: "NAD",
    iso3: "NAM",
    isoNo: "516",
    internet: "NA",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Nauru",
    capital: "no official capital",
    fips: "NR",
    iso2: "NR",
    currency: "AUD",
    iso3: "NRU",
    isoNo: "520",
    internet: "NR",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Nepal",
    capital: "Kathmandu",
    fips: "NP",
    iso2: "NP",
    currency: "NPR",
    iso3: "NPL",
    isoNo: "524",
    internet: "NP",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Netherlands",
    capital: "Amsterdam",
    fips: "NL",
    iso2: "NL",
    currency: "EUR",
    iso3: "NLD",
    isoNo: "528",
    internet: "NL",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Netherlands Antilles",
    capital: "Willemstad",
    fips: "NT",
    iso2: "AN",
    currency: "ANG",
    iso3: "ANT",
    isoNo: "530",
    internet: "AN",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "New Caledonia",
    capital: "Noumea",
    fips: "NC",
    iso2: "NC",
    currency: "XPF",
    iso3: "NCL",
    isoNo: "540",
    internet: "NC",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "New Zealand",
    capital: "Wellington",
    fips: "NZ",
    iso2: "NZ",
    currency: "NZD",
    iso3: "NZL",
    isoNo: "554",
    internet: "NZ",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Nicaragua",
    capital: "Managua",
    fips: "NU",
    iso2: "NI",
    currency: "NIO",
    iso3: "NIC",
    isoNo: "558",
    internet: "NI",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Niger",
    capital: "Niamey",
    fips: "NG",
    iso2: "NE",
    currency: "XOF",
    iso3: "NER",
    isoNo: "562",
    internet: "NE",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Nigeria",
    capital: "Abuja",
    fips: "NI",
    iso2: "NG",
    currency: "NGN",
    iso3: "NGA",
    isoNo: "566",
    internet: "NG",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Niue",
    capital: "Alofi",
    fips: "NE",
    iso2: "NU",
    currency: "NZD",
    iso3: "NIU",
    isoNo: "570",
    internet: "NU",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Norfolk Island",
    capital: "Kingston",
    fips: "NF",
    iso2: "NF",
    currency: "AUD",
    iso3: "NFK",
    isoNo: "574",
    internet: "NF",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Northern Mariana Islands",
    capital: "Saipan",
    fips: "CQ",
    iso2: "MP",
    currency: "USD",
    iso3: "MNP",
    isoNo: "580",
    internet: "MP",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Norway",
    capital: "Oslo",
    fips: "NO",
    iso2: "NO",
    currency: "NOK",
    iso3: "NOR",
    isoNo: "578",
    internet: "NO",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Oman",
    capital: "Muscat",
    fips: "MU",
    iso2: "OM",
    currency: "OMR",
    iso3: "OMN",
    isoNo: "512",
    internet: "OM",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Pakistan",
    capital: "Islamabad",
    fips: "PK",
    iso2: "PK",
    currency: "PKR",
    iso3: "PAK",
    isoNo: "586",
    internet: "PK",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Palau",
    capital: "Koror",
    fips: "PS",
    iso2: "PW",
    currency: "USD",
    iso3: "PLW",
    isoNo: "585",
    internet: "PW",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Palestinian Territory",
    capital: "East Jerusalem",
    fips: "WE",
    iso2: "PS",
    currency: "ILS",
    iso3: "PSE",
    isoNo: "275",
    internet: "PS",
  },
  {
    continent: "Americas",
    region: "Central America",
    country: "Panama",
    capital: "Panama",
    fips: "PM",
    iso2: "PA",
    currency: "PAB",
    iso3: "PAN",
    isoNo: "591",
    internet: "PA",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Papua New Guinea",
    capital: "Port Moresby",
    fips: "PP",
    iso2: "PG",
    currency: "PGK",
    iso3: "PNG",
    isoNo: "598",
    internet: "PG",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Paraguay",
    capital: "Asuncion",
    fips: "PA",
    iso2: "PY",
    currency: "PYG",
    iso3: "PRY",
    isoNo: "600",
    internet: "PY",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Peru",
    capital: "Lima",
    fips: "PE",
    iso2: "PE",
    currency: "PEN",
    iso3: "PER",
    isoNo: "604",
    internet: "PE",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Philippines",
    capital: "Manila",
    fips: "RP",
    iso2: "PH",
    currency: "PHP",
    iso3: "PHL",
    isoNo: "608",
    internet: "PH",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Pitcairn Islands",
    capital: "Adamstown",
    fips: "PC",
    iso2: "PN",
    currency: "NZD",
    iso3: "PCN",
    isoNo: "612",
    internet: "PN",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Poland",
    capital: "Warsaw",
    fips: "PL",
    iso2: "PL",
    currency: "PLN",
    iso3: "POL",
    isoNo: "616",
    internet: "PL",
  },
  {
    continent: "Europe",
    region: "South West Europe",
    country: "Portugal",
    capital: "Lisbon",
    fips: "PO",
    iso2: "PT",
    currency: "EUR",
    iso3: "PRT",
    isoNo: "620",
    internet: "PT",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Puerto Rico",
    capital: "San Juan",
    fips: "RQ",
    iso2: "PR",
    currency: "USD",
    iso3: "PRI",
    isoNo: "630",
    internet: "PR",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Qatar",
    capital: "Doha",
    fips: "QA",
    iso2: "QA",
    currency: "QAR",
    iso3: "QAT",
    isoNo: "634",
    internet: "QA",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Reunion",
    capital: "Saint-Denis",
    fips: "RE",
    iso2: "RE",
    currency: "EUR",
    iso3: "REU",
    isoNo: "638",
    internet: "RE",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Romania",
    capital: "Bucharest",
    fips: "RO",
    iso2: "RO",
    currency: "RON",
    iso3: "ROU",
    isoNo: "642",
    internet: "RO",
  },
  {
    continent: "Asia",
    region: "Northern Asia",
    country: "Russia",
    capital: "Moscow",
    fips: "RS",
    iso2: "RU",
    currency: "RUB",
    iso3: "RUS",
    isoNo: "643",
    internet: "RU",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Rwanda",
    capital: "Kigali",
    fips: "RW",
    iso2: "RW",
    currency: "RWF",
    iso3: "RWA",
    isoNo: "646",
    internet: "RW",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Kitts and Nevis",
    capital: "Basseterre",
    fips: "SC",
    iso2: "KN",
    currency: "XCD",
    iso3: "KNA",
    isoNo: "659",
    internet: "KN",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Lucia",
    capital: "Castries",
    fips: "ST",
    iso2: "LC",
    currency: "XCD",
    iso3: "LCA",
    isoNo: "662",
    internet: "LC",
  },
  {
    continent: "Americas",
    region: "North America",
    country: "Saint Pierre and Miquelon",
    capital: "Saint-Pierre",
    fips: "SB",
    iso2: "PM",
    currency: "EUR",
    iso3: "SPM",
    isoNo: "666",
    internet: "PM",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Vincent and the Grenadines",
    capital: "Kingstown",
    fips: "VC",
    iso2: "VC",
    currency: "XCD",
    iso3: "VCT",
    isoNo: "670",
    internet: "VC",
  },
  {
    continent: "Europe",
    region: "Southern Europe",
    country: "San Marino",
    capital: "San Marino",
    fips: "SM",
    iso2: "SM",
    currency: "EUR",
    iso3: "SMR",
    isoNo: "674",
    internet: "SM",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Sao Tome and Principe",
    capital: "Sao Tome",
    fips: "TP",
    iso2: "ST",
    currency: "STD",
    iso3: "STP",
    isoNo: "678",
    internet: "ST",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Saudi Arabia",
    capital: "Riyadh",
    fips: "SA",
    iso2: "SA",
    currency: "SAR",
    iso3: "SAU",
    isoNo: "682",
    internet: "SA",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Senegal",
    capital: "Dakar",
    fips: "SG",
    iso2: "SN",
    currency: "XOF",
    iso3: "SEN",
    isoNo: "686",
    internet: "SN",
  },
  {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Seychelles",
    capital: "Victoria",
    fips: "SE",
    iso2: "SC",
    currency: "SCR",
    iso3: "SYC",
    isoNo: "690",
    internet: "SC",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Sierra Leone",
    capital: "Freetown",
    fips: "SL",
    iso2: "SL",
    currency: "SLL",
    iso3: "SLE",
    isoNo: "694",
    internet: "SL",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Singapore",
    capital: "Singapore",
    fips: "SN",
    iso2: "SG",
    currency: "SGD",
    iso3: "SGP",
    isoNo: "702",
    internet: "SG",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Slovakia",
    capital: "Bratislava",
    fips: "LO",
    iso2: "SK",
    currency: "EUR",
    iso3: "SVK",
    isoNo: "703",
    internet: "SK",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Slovenia",
    capital: "Ljubljana",
    fips: "SI",
    iso2: "SI",
    currency: "EUR",
    iso3: "SVN",
    isoNo: "705",
    internet: "SI",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Solomon Islands",
    capital: "Honiara",
    fips: "BP",
    iso2: "SB",
    currency: "SBD",
    iso3: "SLB",
    isoNo: "090",
    internet: "SB",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Somalia",
    capital: "Mogadishu",
    fips: "SO",
    iso2: "SO",
    currency: "SOS",
    iso3: "SOM",
    isoNo: "706",
    internet: "SO",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "South Africa",
    capital: "Pretoria��",
    fips: "SF",
    iso2: "ZA",
    currency: "ZAR",
    iso3: "ZAF",
    isoNo: "710",
    internet: "ZA",
  },
  {
    continent: "Europe",
    region: "South West Europe",
    country: "Spain",
    capital: "Madrid",
    fips: "SP",
    iso2: "ES",
    currency: "EUR",
    iso3: "ESP",
    isoNo: "724",
    internet: "ES",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "Sri Lanka",
    capital: "Colombo",
    fips: "CE",
    iso2: "LK",
    currency: "LKR",
    iso3: "LKA",
    isoNo: "144",
    internet: "LK",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Sudan",
    capital: "Khartoum",
    fips: "SU",
    iso2: "SD",
    currency: "SDG",
    iso3: "SDN",
    isoNo: "729",
    internet: "SD",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Suriname",
    capital: "Paramaribo",
    fips: "NS",
    iso2: "SR",
    currency: "SRD",
    iso3: "SUR",
    isoNo: "740",
    internet: "SR",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Svalbard",
    capital: "Longyearbyen",
    fips: "SV",
    iso2: "SJ",
    currency: "NOK",
    iso3: "SJM",
    isoNo: "744",
    internet: "SJ",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Eswatini",
    capital: "Mbabane",
    fips: "WZ",
    iso2: "SZ",
    currency: "SZL",
    iso3: "SWZ",
    isoNo: "748",
    internet: "SZ",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Sweden",
    capital: "Stockholm",
    fips: "SW",
    iso2: "SE",
    currency: "SEK",
    iso3: "SWE",
    isoNo: "752",
    internet: "SE",
  },
  {
    continent: "Europe",
    region: "Central Europe",
    country: "Switzerland",
    capital: "Bern",
    fips: "SZ",
    iso2: "CH",
    currency: "CHF",
    iso3: "CHE",
    isoNo: "756",
    internet: "CH",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Syria",
    capital: "Damascus",
    fips: "SY",
    iso2: "SY",
    currency: "SYP",
    iso3: "SYR",
    isoNo: "760",
    internet: "SY",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "Taiwan",
    capital: "Taipei",
    fips: "TW",
    iso2: "TW",
    currency: "TWD",
    iso3: "TWN",
    isoNo: "158",
    internet: "TW",
  },
  {
    continent: "Asia",
    region: "Central Asia",
    country: "Tajikistan",
    capital: "Dushanbe",
    fips: "TI",
    iso2: "TJ",
    currency: "TJS",
    iso3: "TJK",
    isoNo: "762",
    internet: "TJ",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Tanzania",
    capital: "Dar es Salaam",
    fips: "TZ",
    iso2: "TZ",
    currency: "TZS",
    iso3: "TZA",
    isoNo: "834",
    internet: "TZ",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Thailand",
    capital: "Bangkok",
    fips: "TH",
    iso2: "TH",
    currency: "THB",
    iso3: "THA",
    isoNo: "764",
    internet: "TH",
  },
  {
    continent: "Africa",
    region: "Western Africa",
    country: "Togo",
    capital: "Lome",
    fips: "TO",
    iso2: "TG",
    currency: "XOF",
    iso3: "TGO",
    isoNo: "768",
    internet: "TG",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Tokelau",
    capital: "none",
    fips: "TL",
    iso2: "TK",
    currency: "NZD",
    iso3: "TKL",
    isoNo: "772",
    internet: "TK",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Tonga",
    capital: "Nuku'alofa",
    fips: "TN",
    iso2: "TO",
    currency: "TOP",
    iso3: "TON",
    isoNo: "776",
    internet: "TO",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Trinidad and Tobago",
    capital: "Port-of-Spain",
    fips: "TD",
    iso2: "TT",
    currency: "TTD",
    iso3: "TTO",
    isoNo: "780",
    internet: "TT",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Tunisia",
    capital: "Tunis",
    fips: "TS",
    iso2: "TN",
    currency: "TND",
    iso3: "TUN",
    isoNo: "788",
    internet: "TN",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Turkey",
    capital: "Ankara",
    fips: "TU",
    iso2: "TR",
    currency: "TRY",
    iso3: "TUR",
    isoNo: "792",
    internet: "TR",
  },
  {
    continent: "Asia",
    region: "Central Asia",
    country: "Turkmenistan",
    capital: "Ashgabat",
    fips: "TX",
    iso2: "TM",
    currency: "TMT",
    iso3: "TKM",
    isoNo: "795",
    internet: "TM",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Turks and Caicos Islands",
    capital: "Grand Turk",
    fips: "TK",
    iso2: "TC",
    currency: "USD",
    iso3: "TCA",
    isoNo: "796",
    internet: "TC",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Tuvalu",
    capital: "Funafuti",
    fips: "TV",
    iso2: "TV",
    currency: "AUD",
    iso3: "TUV",
    isoNo: "798",
    internet: "TV",
  },
  {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Uganda",
    capital: "Kampala",
    fips: "UG",
    iso2: "UG",
    currency: "UGX",
    iso3: "UGA",
    isoNo: "800",
    internet: "UG",
  },
  {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Ukraine",
    capital: "Kyiv",
    fips: "UP",
    iso2: "UA",
    currency: "UAH",
    iso3: "UKR",
    isoNo: "804",
    internet: "UA",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "United Arab Emirates",
    capital: "Abu Dhabi",
    fips: "TC",
    iso2: "AE",
    currency: "AED",
    iso3: "ARE",
    isoNo: "784",
    internet: "AE",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "United Kingdom",
    capital: "London",
    fips: "UK",
    iso2: "GB",
    currency: "GBP",
    iso3: "GBR",
    isoNo: "826",
    internet: "GB",
  },
  {
    continent: "Americas",
    region: "North America",
    country: "United States",
    capital: "Washington DC",
    fips: "US",
    iso2: "US",
    currency: "USD",
    iso3: "USA",
    isoNo: "840",
    internet: "US",
  },
  {
    continent: "Americas",
    region: "North America",
    country: "United States Minor Outlying Islands",
    capital: "Washington DC",
    fips: "",
    iso2: "UM",
    currency: "USD",
    iso3: "UMI",
    isoNo: "581",
    internet: "US",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Uruguay",
    capital: "Montevideo",
    fips: "UY",
    iso2: "UY",
    currency: "UYU",
    iso3: "URY",
    isoNo: "858",
    internet: "UY",
  },
  {
    continent: "Asia",
    region: "Central Asia",
    country: "Uzbekistan",
    capital: "Tashkent (Toshkent)",
    fips: "UZ",
    iso2: "UZ",
    currency: "UZS",
    iso3: "UZB",
    isoNo: "860",
    internet: "UZ",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Vanuatu",
    capital: "Port-Vila",
    fips: "NH",
    iso2: "VU",
    currency: "VUV",
    iso3: "VUT",
    isoNo: "548",
    internet: "VU",
  },
  {
    continent: "Americas",
    region: "South America",
    country: "Venezuela",
    capital: "Caracas",
    fips: "VE",
    iso2: "VE",
    currency: "VEF",
    iso3: "VEN",
    isoNo: "862",
    internet: "UE",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Vietnam",
    capital: "Hanoi",
    fips: "VN",
    iso2: "VN",
    currency: "VND",
    iso3: "VNM",
    isoNo: "704",
    internet: "VN",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Virgin Islands",
    capital: "Charlotte Amalie",
    fips: "VQ",
    iso2: "VI",
    currency: "USD",
    iso3: "VIR",
    isoNo: "850",
    internet: "VI",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Wallis and Futuna",
    capital: "Mata-Utu (on Ile Uvea)",
    fips: "WF",
    iso2: "WF",
    currency: "XPF",
    iso3: "WLF",
    isoNo: "876",
    internet: "WF",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "Western Sahara",
    capital: "none",
    fips: "WI",
    iso2: "EH",
    currency: "MAD",
    iso3: "ESH",
    isoNo: "732",
    internet: "EH",
  },
  {
    continent: "Oceania",
    region: "Pacific",
    country: "Western Samoa",
    capital: "Apia",
    fips: "WS",
    iso2: "WS",
    currency: "WST",
    iso3: "WSM",
    isoNo: "882",
    internet: "WS",
  },
  {
    continent: "Asia",
    region: "South West Asia",
    country: "Yemen",
    capital: "Sanaa",
    fips: "YM",
    iso2: "YE",
    currency: "YER",
    iso3: "YEM",
    isoNo: "887",
    internet: "YE",
  },
  {
    continent: "Africa",
    region: "Central Africa",
    country: "Democratic Republic of the Congo",
    capital: "Kinshasa",
    fips: "CG",
    iso2: "CD",
    currency: "CDF",
    iso3: "COD",
    isoNo: "180",
    internet: "ZR",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Zambia",
    capital: "Lusaka",
    fips: "ZA",
    iso2: "ZM",
    currency: "ZMW",
    iso3: "ZMB",
    isoNo: "894",
    internet: "ZM",
  },
  {
    continent: "Africa",
    region: "Southern Africa",
    country: "Zimbabwe",
    capital: "Harare",
    fips: "ZI",
    iso2: "ZW",
    currency: "ZWL",
    iso3: "ZWE",
    isoNo: "716",
    internet: "ZW",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "Hong Kong",
    capital: "Victoria",
    fips: "HK",
    iso2: "HK",
    currency: "HKD",
    iso3: "HKG",
    isoNo: "344",
    internet: "HK",
  },
  {
    continent: "Asia",
    region: "East Asia",
    country: "Macau",
    capital: "Macau",
    fips: "MC",
    iso2: "MO",
    currency: "MOP",
    iso3: "MAC",
    isoNo: "446",
    internet: "MO",
  },
  {
    continent: "Antarctica",
    region: "Antarctica",
    country: "Antarctica",
    capital: "",
    fips: "AY",
    iso2: "AQ",
    currency: "AAD",
    iso3: "ATA",
    isoNo: "010",
    internet: "AQ",
  },
  {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "Bouvet Island",
    capital: "",
    fips: "BV",
    iso2: "BV",
    currency: "NOK",
    iso3: "BVT",
    isoNo: "074",
    internet: "BV",
  },
  {
    continent: "Asia",
    region: "South Asia",
    country: "British Indian Ocean Territory",
    capital: "",
    fips: "IO",
    iso2: "IO",
    currency: "USD",
    iso3: "IOT",
    isoNo: "086",
    internet: "IO",
  },
  {
    continent: "Indian Ocean",
    region: "Southern Indian Ocean",
    country: "French Southern and Antarctic Lands",
    capital: "",
    fips: "FS",
    iso2: "TF",
    currency: "EUR",
    iso3: "ATF",
    isoNo: "260",
    internet: "--",
  },
  {
    continent: "Indian Ocean",
    region: "Southern Indian Ocean",
    country: "Heard Island and McDonald Islands",
    capital: "",
    fips: "HM",
    iso2: "HM",
    currency: "AUD",
    iso3: "HMD",
    isoNo: "334",
    internet: "HM",
  },
  {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "Saint Helena",
    capital: "",
    fips: "SH",
    iso2: "SH",
    currency: "SHP",
    iso3: "SHN",
    isoNo: "654",
    internet: "SH",
  },
  {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "South Georgia and the South Sandwich Islands",
    capital: "",
    fips: "SX",
    iso2: "GS",
    currency: "GBP",
    iso3: "SGS",
    isoNo: "239",
    internet: "GS",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Guernsey",
    capital: "Saint Peter Port",
    fips: "GK",
    iso2: "GG",
    currency: "GBP",
    iso3: "GGY",
    isoNo: "831",
    internet: "GG",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Serbia",
    capital: "Belgrade",
    fips: "RI",
    iso2: "RS",
    currency: "RSD",
    iso3: "SRB",
    isoNo: "688",
    internet: "RS",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Barthélemy",
    capital: "Gustavia",
    fips: "TB",
    iso2: "BL",
    currency: "EUR",
    iso3: "BLM",
    isoNo: "652",
    internet: "BL",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Montenegro",
    capital: "Podgorica",
    fips: "MJ",
    iso2: "ME",
    currency: "EUR",
    iso3: "MNE",
    isoNo: "499",
    internet: "ME",
  },
  {
    continent: "Europe",
    region: "Western Europe",
    country: "Jersey",
    capital: "Saint Helier",
    fips: "JE",
    iso2: "JE",
    currency: "GBP",
    iso3: "JEY",
    isoNo: "832",
    internet: "JE",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Curaçao",
    capital: "Willemstad",
    fips: "UC",
    iso2: "CW",
    currency: "ANG",
    iso3: "CUW",
    isoNo: "531",
    internet: "CW",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Martin",
    capital: "Marigot",
    fips: "RN",
    iso2: "MF",
    currency: "EUR",
    iso3: "MAF",
    isoNo: "663",
    internet: "MF",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Sint Maarten",
    capital: "Philipsburg",
    fips: "NN",
    iso2: "SX",
    currency: "ANG",
    iso3: "SXM",
    isoNo: "534",
    internet: "SX",
  },
  {
    continent: "Asia",
    region: "South East Asia",
    country: "Timor-Leste",
    capital: "Dili",
    fips: "TT",
    iso2: "TL",
    currency: "USD",
    iso3: "TLS",
    isoNo: "626",
    internet: "TL",
  },
  {
    continent: "Africa",
    region: "Northern Africa",
    country: "South Sudan",
    capital: "Juba",
    fips: "OD",
    iso2: "SS",
    currency: "SSP",
    iso3: "SSD",
    isoNo: "728",
    internet: "SS",
  },
  {
    continent: "Europe",
    region: "Northern Europe",
    country: "Åland Islands",
    capital: "Mariehamn",
    fips: "AX",
    iso2: "AX",
    currency: "EUR",
    iso3: "ALA",
    isoNo: "248",
    internet: "AX",
  },
  {
    continent: "Americas",
    region: "West Indies",
    country: "Bonaire",
    capital: "Kralendijk",
    fips: "BQ",
    iso2: "BQ",
    currency: "USD",
    iso3: "BES",
    isoNo: "535",
    internet: "BQ",
  },
  {
    continent: "Europe",
    region: "South East Europe",
    country: "Republic of Kosovo",
    capital: "Pristina",
    fips: "KV",
    iso2: "XK",
    currency: "EUR",
    iso3: "XKX",
    isoNo: null,
    internet: "XK",
  },
];

export const DROPDOWN_API = {
  COMPLAINT: "complaints",
  DIAGNOSIS: "diagnoses",
  IOP: "iops",
  VISUAL_ACUITY: "visual-acuities",
  NEAR_VISUAL_ACUITY: "near-visual-acuities",
  ASTIGMATISM: "astigmatism-diopters",
  KERATOMETRY_DIOPTERS: "keratometry-diopters",
  SPHERICAL_DIOPTERS: "spherical-diopters",
  CYLINDRICAL_DIOPTERS: "cylindrical-dioptres",
  CONJUNCTIVA: "conjunctivas",
  AC: "anterior-chambers",
  IRIS: "irises",
  LENS: "lenses",
  VITREOUS: "vitreous",
  PUPILS: "pupils",
  ORBIT: "orbits",
  LIDS: "lids",
  CORNEA: "corneas",
  SCLERA: "scleras",
  BINOCULAR: "binocular-vision",
  COLOUR_VISION: "colour-vision",
  EYE_ALIGNMENT: "eye-alignment",
  PERIPHERAL_VISION: "peripheral-vision",
  LOW_LIGHT_VISION: "low-vision",
  OPTIC_NERVE_DISC: "optic-nerve-discs",
  VESSELS: "fundus-vessels",
  MACULA: "maculas",
  RETINA: "retinas",
  PERIPHERY: "periphery",
  EXTRA_OCULAR_MUSCLE: "eom-grades",
  ANAESTHESIA: "anaesthesia",
  WOUNDS: "wounds",
  FUNDUS_VESSELS: "fundus-vessels",
  IOL_POSITIONS: "iol-positions",
  IOL_TYPES: "iol-types",
  ANTERIOR_CHAMBERS: "anterior-chambers",
  PCS: "posterior-capsules",
  ADD: "addition-powers",
  FIT_HEIGHT: "fit-heights",
  AXIS: "axes",
  LENS_POWER: "lens-powers",
  BASE_CURVATURE: "base-curves",
  PRISM: "prism-dioptres",
  VISCO: "visco-batches",
  INTRA_OP_FLUID: "intraop-fluid-batches",
  COMPLICATIONS: "complications",
  INTRACAMERAL: "intracameral",
  SYSTEMIC_CONDITIONS: "systemic-conditions",
  FAMILY_HISTORY: "family-histories",
  MEDICAL_HISTORY: "medical-histories",
  ALLERGY: "allergies",
  RELIGION: "religions",
  GENOTYPE: "genotypes",
  BLOOD_GROUP: "blood-groups",
  REFERRALS: "referrals",
};

export const DROPDOWN_API_PARAM = {
  [DROPDOWN_API.COMPLAINT]: "names",
  [DROPDOWN_API.DIAGNOSIS]: "names",
};

export const DROPDOWN_API_PAYLOAD = {
  [DROPDOWN_API.COMPLAINT]: { names: "", specialties: "" },
  [DROPDOWN_API.DIAGNOSIS]: { names: "", specialties: "" },
  [DROPDOWN_API.VISUAL_ACUITY]: { values: "" },
  [DROPDOWN_API.IOP]: { values: "" },
};

export const FEATURE_TYPES = /** @type {const} */ ({
  LAB_TRACKING: "lab-tracking",
});

export const BRANCH_BILLING_SERVICES = /** @type {const} */ ([
  { key: "patientAppointmentFee", label: "Patient Appt Fee", defaultWallet: "organization", canSwitch: true },
  { key: "servicesSubscription", label: "Lab Tracking", defaultWallet: "organization", canSwitch: false },
  { key: "sms", label: "SMS", defaultWallet: "organization", canSwitch: true },
]);

export const DEFAULT_BRANCH_BILLING = BRANCH_BILLING_SERVICES.reduce(
  (billing, service) => {
    billing[service.key] = service.defaultWallet;
    return billing;
  },
  { enabled: true },
);

export const TAB_SYNC_KEY = "mvp_app_sync";
export const PAYMENT_METHODS = /** @type {const} */ ({
  CASH: "cash",
  POS: "pos",
  REFUND: "refund",
  TRANSFER: "transfer",
  CHEQUE: "cheque",
  DIRECT_LODGEMENT: "direct-lodgement",
  ONLINE: "online",
  WALLET: "wallet",
  AGENT: "agent",
});

/**
 * @typedef {typeof FEATURE_TYPES[keyof typeof FEATURE_TYPES]} FeatureType
 */
